export const PACKAGE_ORDER = ['basic', 'silver', 'gold', 'platinum'];

export const PACKAGE_NAME_MAP = {
  basic: 'Basic',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum'
};

export const LEGACY_PLAN_TO_PACKAGE = {
  diy: 'basic',
  managed: 'silver',
  corporate: 'gold'
};

export const PACKAGE_ALIASES = {
  basic: 'basic',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
  diy: 'basic',
  managed: 'silver',
  corporate: 'gold',
  starter: 'basic',
  growth: 'silver',
  pro: 'gold',
  enterprise: 'platinum'
};

export const PACKAGES = [
  {
    id: 'basic',
    name: 'Basic',
    price: 500,
    period: '/month',
    description: 'Strong SEO foundation for small businesses.',
    highlights: [
      '30 keywords',
      '40 backlinks / month',
      '10 target pages optimized',
      'Complete on-page optimization',
      'Off-page + social distribution included'
    ],
    cta: 'Get Started'
  },
  {
    id: 'silver',
    name: 'Silver',
    price: 800,
    period: '/month',
    description: 'Balanced growth package with local SEO support.',
    badge: 'Most Popular',
    popular: true,
    highlights: [
      '40 keywords',
      '60 backlinks / month',
      '15 target pages optimized',
      'GBP optimization included',
      'Higher social + submission volume'
    ],
    cta: 'Get Started'
  },
  {
    id: 'gold',
    name: 'Gold',
    price: 1200,
    period: '/month',
    description: 'Performance-focused package for scaling teams.',
    highlights: [
      '50 keywords',
      '100 backlinks / month',
      '25 target pages optimized',
      'Advanced SEO analysis + geotagging',
      'Infographics + PPT submissions'
    ],
    cta: 'Get Started'
  },
  {
    id: 'platinum',
    name: 'Platinum',
    price: 1800,
    period: '/month',
    description: 'Maximum visibility and aggressive market growth.',
    badge: 'Enterprise',
    highlights: [
      '100 keywords',
      '200 backlinks / month',
      '40 target pages optimized',
      'Highest off-page and social volume',
      'Press release + LinkedIn execution'
    ],
    cta: 'Get Started'
  }
];

export const PACKAGE_FEATURE_MATRIX = [
  {
    section: 'Plan Overview',
    rows: [
      { feature: 'Monthly Price', values: { basic: '$500', silver: '$800', gold: '$1200', platinum: '$1800' } },
      { feature: 'No. of Keywords', values: { basic: '30', silver: '40', gold: '50', platinum: '100' } },
      { feature: 'Backlinks (per month)', values: { basic: '40', silver: '60', gold: '100', platinum: '200' } },
      { feature: 'Target Pages Optimized', values: { basic: 'Up to 10', silver: 'Up to 15', gold: 'Up to 25', platinum: 'Up to 40' } },
      { feature: 'GBP (GMB)', values: { basic: false, silver: true, gold: true, platinum: true } },
      { feature: 'Geotagging', values: { basic: false, silver: false, gold: true, platinum: true } }
    ]
  },
  {
    section: 'First Hand SEO Analysis',
    rows: [
      { feature: 'Pre-Optimization Website Analysis', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Competitor Analysis', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Keyword Research and Analysis', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Baseline Ranking Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Duplicate Content Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Google Penalty Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Backlink Analysis (if required)', values: { basic: false, silver: false, gold: true, platinum: true } }
    ]
  },
  {
    section: 'On-Page Optimization Activities',
    rows: [
      { feature: 'Website Canonical Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Title Tag Optimization', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Meta Tags Optimization', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Heading Tags Optimization', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Image Alt Tags Optimization', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Content Optimization', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'SEO Friendly URL Setup', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Site Navigation Analysis', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: '404 Page Implementation', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Broken Links Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Website Speed Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Google Indexed Pages Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Robots.txt Creation', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Google XML Sitemap', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'HTML Sitemap (if available)', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Hyperlink Optimization', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Website Responsive Check', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Website Permalinks Analysis', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Internal Linking Optimization', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Google Webmaster Tools Setup', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Bing Webmaster Tools Setup', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Google Analytics Setup', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Structured Data Setup', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'On-Site Blog Section Creation', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'On-Site Blog Posting (from month 1)', values: { basic: '1', silver: '2', gold: '4', platinum: '5' } }
    ]
  },
  {
    section: 'Off-Page Optimization Activities',
    rows: [
      { feature: 'Search Engine Submission', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Blog Writing', values: { basic: '2', silver: '2', gold: '3', platinum: '5' } },
      { feature: 'Blog Links', values: { basic: '2', silver: '2', gold: '3', platinum: '5' } },
      { feature: 'Blog Social Bookmarking Links', values: { basic: '6', silver: '10', gold: '16', platinum: '35' } },
      { feature: 'Article Writing', values: { basic: '1', silver: '2', gold: '3', platinum: '4' } },
      { feature: 'Article Submissions', values: { basic: '1', silver: '2', gold: '3', platinum: '4' } },
      { feature: 'Article Marketing', values: { basic: '5', silver: '10', gold: '15', platinum: '25' } },
      { feature: 'Image Sharing', values: { basic: '2', silver: '4', gold: '8', platinum: '12' } },
      { feature: 'Contextual Links', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Keyword Used in Anchor Text', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Share each blog post across social networks', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Web 2.0 Profile Creation', values: { basic: '0', silver: '1', gold: '2', platinum: '5' } },
      { feature: 'Web 2.0 Profile Bookmarking Links', values: { basic: '0', silver: '4', gold: '10', platinum: '25' } },
      { feature: 'Press Release (if client provides news)', values: { basic: false, silver: false, gold: false, platinum: true } },
      { feature: 'Press Release Bookmarking Links', values: { basic: false, silver: false, gold: false, platinum: true } },
      { feature: 'Social Bookmarking Links', values: { basic: '15', silver: '24', gold: '30', platinum: '60' } },
      { feature: 'Micro Blogging', values: { basic: '4', silver: '7', gold: '12', platinum: '20' } },
      { feature: 'Classified Submissions', values: { basic: '5', silver: '8', gold: '12', platinum: '25' } },
      { feature: 'Infographics Creation / Month', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Infographics Post / Month', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Share each infographic on social networks', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Google Business Page Creation', values: { basic: false, silver: true, gold: true, platinum: true } },
      { feature: 'Bing Local Listing Creation', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'PPT Submissions', values: { basic: '0', silver: '0', gold: '1', platinum: '3' } },
      { feature: 'Video Marketing (if client provides)', values: { basic: true, silver: true, gold: true, platinum: true } },
      { feature: 'Location Optimization', values: { basic: '1', silver: '2', gold: '4', platinum: '10' } },
      { feature: 'Local Business Listings', values: { basic: '1', silver: '2', gold: '4', platinum: '10' } },
      { feature: 'NAP Syndication', values: { basic: true, silver: true, gold: true, platinum: true } }
    ]
  },
  {
    section: 'SMO Activities',
    rows: [
      { feature: 'Facebook Profile Creation', values: { basic: false, silver: true, gold: true, platinum: true } },
      { feature: 'Facebook Fan Page Creation', values: { basic: false, silver: true, gold: true, platinum: true } },
      { feature: 'Facebook Posting and Sharing', values: { basic: '0', silver: '4', gold: '8', platinum: '16' } },
      { feature: 'Instagram Profile Creation', values: { basic: false, silver: true, gold: true, platinum: true } },
      { feature: 'Instagram Posting and Sharing', values: { basic: false, silver: true, gold: '8', platinum: '16' } },
      { feature: 'Twitter Profile Creation', values: { basic: false, silver: true, gold: true, platinum: true } },
      { feature: 'Twitter Posts', values: { basic: '0', silver: '4', gold: '8', platinum: '16' } },
      { feature: 'Pinterest Account Creation and Management', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'Updating Pin Boards', values: { basic: false, silver: false, gold: '8', platinum: '16' } },
      { feature: 'Pins (if client provides images)', values: { basic: false, silver: false, gold: true, platinum: true } },
      { feature: 'LinkedIn Profile Creation', values: { basic: false, silver: false, gold: false, platinum: true } },
      { feature: 'LinkedIn Posting and Sharing', values: { basic: false, silver: false, gold: false, platinum: '16' } }
    ]
  }
];

export function getCurrentPackageId(subscription) {
  if (!subscription) {
    return null;
  }

  const normalize = (value) => {
    if (!value) return null;

    let raw = String(value).trim();
    if (!raw) return null;

    // Handles values like "PackageType.GOLD", "PlanType.MANAGED"
    if (raw.includes('.')) {
      raw = raw.split('.').pop() || raw;
    }

    const lower = raw.toLowerCase();
    return PACKAGE_ALIASES[lower] || null;
  };

  const fromPackageType = normalize(subscription.package_type);
  if (fromPackageType) {
    return fromPackageType;
  }

  const fromPackageField = normalize(subscription.package);
  if (fromPackageField) {
    return fromPackageField;
  }

  const fromPlan = normalize(subscription.plan);
  if (fromPlan) {
    return fromPlan;
  }

  return null;
}

export function formatPackageName(packageId) {
  return PACKAGE_NAME_MAP[packageId] || packageId || '';
}
